import { render, staticRenderFns } from "./CommonDropzoneWithCashFlowUpload.vue?vue&type=template&id=485d06e6&lang=pug&"
import script from "./CommonDropzoneWithCashFlowUpload.vue?vue&type=script&lang=ts&"
export * from "./CommonDropzoneWithCashFlowUpload.vue?vue&type=script&lang=ts&"
import style0 from "./CommonDropzoneWithCashFlowUpload.vue?vue&type=style&index=0&id=485d06e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports